
// Centralized vendor category enum
export const VendorCategory = {
  FB: 'F&B',
  DECOR: 'Decor',
  PHOTOGRAPHY_VIDEOGRAPHY: 'Photography/Videography',
  ENTERTAINMENT: 'Entertainment',
  CATERING: 'Catering',
  VENUE: 'Venue',
  AUDIO_VISUAL: 'Audio/Visual',
  SECURITY: 'Security',
  TRANSPORTATION: 'Transportation',
  FLOWERS: 'Flowers',
  LIGHTING: 'Lighting',
  MARKETING: 'Marketing',
  OTHER: 'Other'
} as const;

export type VendorCategoryType = typeof VendorCategory[keyof typeof VendorCategory];

// Array of all categories for dropdowns
export const VENDOR_CATEGORIES: VendorCategoryType[] = [
  VendorCategory.FB,
  VendorCategory.DECOR,
  VendorCategory.PHOTOGRAPHY_VIDEOGRAPHY,
  VendorCategory.ENTERTAINMENT,
  VendorCategory.CATERING,
  VendorCategory.VENUE,
  VendorCategory.AUDIO_VISUAL,
  VendorCategory.SECURITY,
  VendorCategory.TRANSPORTATION,
  VendorCategory.FLOWERS,
  VendorCategory.LIGHTING,
  VendorCategory.MARKETING,
  VendorCategory.OTHER
];

// Helper function to get category color for UI
export const getCategoryColor = (category: VendorCategoryType): string => {
  const colors: Record<VendorCategoryType, string> = {
    [VendorCategory.FB]: 'bg-blue-100 text-blue-800 border-blue-200',
    [VendorCategory.DECOR]: 'bg-purple-100 text-purple-800 border-purple-200',
    [VendorCategory.PHOTOGRAPHY_VIDEOGRAPHY]: 'bg-pink-100 text-pink-800 border-pink-200',
    [VendorCategory.ENTERTAINMENT]: 'bg-green-100 text-green-800 border-green-200',
    [VendorCategory.CATERING]: 'bg-orange-100 text-orange-800 border-orange-200',
    [VendorCategory.VENUE]: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    [VendorCategory.AUDIO_VISUAL]: 'bg-cyan-100 text-cyan-800 border-cyan-200',
    [VendorCategory.SECURITY]: 'bg-gray-100 text-gray-800 border-gray-200',
    [VendorCategory.TRANSPORTATION]: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    [VendorCategory.FLOWERS]: 'bg-rose-100 text-rose-800 border-rose-200',
    [VendorCategory.LIGHTING]: 'bg-amber-100 text-amber-800 border-amber-200',
    [VendorCategory.MARKETING]: 'bg-teal-100 text-teal-800 border-teal-200',
    [VendorCategory.OTHER]: 'bg-slate-100 text-slate-800 border-slate-200'
  };
  return colors[category] || colors[VendorCategory.OTHER];
};
